import { render } from "./GallerySection.vue?vue&type=template&id=2075e2de&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"

import "./GallerySection.vue?vue&type=style&index=0&id=2075e2de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2075e2de"]])

export default __exports__